import { useState, useEffect } from 'react';

export type TransitionType = 'fade' | 'slide' | 'scale' | 'slide-up' | 'slide-down' | 'slide-left';

interface UsePageTransitionOptions {
  delay?: number;
  transitionType?: TransitionType;
}

export const usePageTransition = (options: UsePageTransitionOptions = {}) => {
  const { delay = 50, transitionType = 'fade' } = options;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);
    
    return () => clearTimeout(timer);
  }, [delay]);

  const getTransitionClasses = () => {
    return `page-transition-container ${transitionType} ${isVisible ? 'visible' : ''}`;
  };

  return {
    isVisible,
    getTransitionClasses,
    transitionType
  };
}; 